function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.24988 29.8262C6.24988 24.1911 10.818 19.623 16.453 19.623H17.0936C22.7287 19.623 27.2968 24.1911 27.2968 29.8262H6.24988Z",
  fill: "url(#paint0_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24988 29.8262C6.24988 24.1911 10.818 19.623 16.453 19.623H17.0936C22.7287 19.623 27.2968 24.1911 27.2968 29.8262H6.24988Z",
  fill: "url(#paint1_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24988 29.8262C6.24988 24.1911 10.818 19.623 16.453 19.623H17.0936C22.7287 19.623 27.2968 24.1911 27.2968 29.8262H6.24988Z",
  fill: "url(#paint2_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24988 29.8262C6.24988 24.1911 10.818 19.623 16.453 19.623H17.0936C22.7287 19.623 27.2968 24.1911 27.2968 29.8262H6.24988Z",
  fill: "url(#paint3_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.24988 29.8262C6.24988 24.1911 10.818 19.623 16.453 19.623H17.0936C22.7287 19.623 27.2968 24.1911 27.2968 29.8262H6.24988Z",
  fill: "url(#paint4_radial_3987_23845)"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.33191,
  cy: 12.8379,
  r: 1.68359,
  fill: "url(#paint5_radial_3987_23845)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.33191,
  cy: 12.8379,
  r: 1.68359,
  fill: "url(#paint6_radial_3987_23845)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.24597,
  cy: 3.85742,
  r: 1.68359,
  fill: "url(#paint7_radial_3987_23845)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.24597,
  cy: 3.85742,
  r: 1.68359,
  fill: "url(#paint8_radial_3987_23845)"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.2108,
  cy: 4.87305,
  r: 1.68359,
  fill: "url(#paint9_radial_3987_23845)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.2108,
  cy: 4.87305,
  r: 1.68359,
  fill: "url(#paint10_radial_3987_23845)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.2343,
  cy: 14.8301,
  r: 1.68359,
  fill: "url(#paint11_radial_3987_23845)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.2343,
  cy: 14.8301,
  r: 1.68359,
  fill: "url(#paint12_radial_3987_23845)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.2343,
  cy: 14.8301,
  r: 1.68359,
  fill: "url(#paint13_radial_3987_23845)"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_di_3987_23845)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.7609,
  cy: 28.2957,
  r: 0.739014,
  fill: "url(#paint14_radial_3987_23845)"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_di_3987_23845)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.7609,
  cy: 26.2825,
  r: 0.739014,
  fill: "url(#paint15_radial_3987_23845)"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M22.222 29.8263H20.6439V20.2578C21.194 20.462 21.7216 20.7122 22.222 21.0038V29.8263Z",
  fill: "url(#paint16_radial_3987_23845)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M22.222 29.8263H20.6439V20.2578C21.194 20.462 21.7216 20.7122 22.222 21.0038V29.8263Z",
  fill: "url(#paint17_linear_3987_23845)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M22.222 29.8263H20.6439V20.2578C21.194 20.462 21.7216 20.7122 22.222 21.0038V29.8263Z",
  fill: "url(#paint18_linear_3987_23845)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8568 29.8262H11.2787V21.0306C11.7789 20.7356 12.3065 20.4822 12.8568 20.2749V29.8262Z",
  fill: "url(#paint19_radial_3987_23845)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8568 29.8262H11.2787V21.0306C11.7789 20.7356 12.3065 20.4822 12.8568 20.2749V29.8262Z",
  fill: "url(#paint20_radial_3987_23845)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8568 29.8262H11.2787V21.0306C11.7789 20.7356 12.3065 20.4822 12.8568 20.2749V29.8262Z",
  fill: "url(#paint21_radial_3987_23845)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8568 29.8262H11.2787V21.0306C11.7789 20.7356 12.3065 20.4822 12.8568 20.2749V29.8262Z",
  fill: "url(#paint22_radial_3987_23845)"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6766 20.0054L14.2892 23.2246H19.2345L20.0311 20.0522C19.101 19.773 18.1149 19.623 17.0939 19.623H16.4532C15.4908 19.623 14.5594 19.7563 13.6766 20.0054Z",
  fill: "url(#paint23_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6766 20.0054L14.2892 23.2246H19.2345L20.0311 20.0522C19.101 19.773 18.1149 19.623 17.0939 19.623H16.4532C15.4908 19.623 14.5594 19.7563 13.6766 20.0054Z",
  fill: "url(#paint24_radial_3987_23845)"
}));

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 5.43738,
  y: 21.7637,
  width: 4.09375,
  height: 8.0625,
  fill: "url(#paint25_linear_3987_23845)"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 5.43738,
  y: 21.7637,
  width: 4.09375,
  height: 8.0625,
  fill: "url(#paint26_linear_3987_23845)"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 23.7772,
  y: 24.1074,
  width: 4.09375,
  height: 5.71875,
  fill: "url(#paint27_linear_3987_23845)"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 23.7772,
  y: 24.1074,
  width: 4.09375,
  height: 5.71875,
  fill: "url(#paint28_linear_3987_23845)"
});

var _ref26 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0218 23.7231C15.8094 23.4765 15.452 23.1889 14.8663 22.9904C14.5051 22.8679 14.0886 22.9228 13.8956 23.2576C13.7553 23.501 13.6112 23.8615 13.6112 24.3629C13.6112 24.8643 13.7553 25.2248 13.8956 25.4682C14.0886 25.8029 14.5051 25.8579 14.8663 25.7354C15.4703 25.5307 15.8314 25.2609 16.0412 25.0293C16.0892 25.1643 16.2 25.2687 16.3456 25.2965C16.6364 25.352 16.8896 25.352 17.1804 25.2965C17.3319 25.2675 17.4459 25.1556 17.4904 25.0124C17.6978 25.2477 18.0616 25.5257 18.6804 25.7354C19.0416 25.8579 19.458 25.8029 19.651 25.4682C19.7913 25.2248 19.9354 24.8697 19.9354 24.3629C19.9354 23.8561 19.7913 23.501 19.651 23.2576C19.458 22.9228 19.0416 22.8679 18.6804 22.9904C18.0781 23.1945 17.7173 23.4927 17.5073 23.7438C17.4849 23.5642 17.3587 23.4154 17.1804 23.3813C16.8896 23.3258 16.6364 23.3258 16.3456 23.3813C16.1742 23.4141 16.0509 23.5529 16.0218 23.7231Z",
  fill: "#BC9EBB"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.8663 22.463C15.7752 22.7711 16.1341 23.2935 16.2549 23.5446L16.283 23.8356L16.2549 24.1936C16.1341 24.4446 15.7752 24.9 14.8663 25.2081C14.5051 25.3305 14.0886 25.2756 13.8956 24.9409C13.7553 24.6975 13.6112 24.3369 13.6112 23.8356C13.6112 23.3342 13.7553 22.9736 13.8956 22.7303C14.0886 22.3955 14.5051 22.3406 14.8663 22.463Z",
  fill: "url(#paint29_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8663 22.463C15.7752 22.7711 16.1341 23.2935 16.2549 23.5446L16.283 23.8356L16.2549 24.1936C16.1341 24.4446 15.7752 24.9 14.8663 25.2081C14.5051 25.3305 14.0886 25.2756 13.8956 24.9409C13.7553 24.6975 13.6112 24.3369 13.6112 23.8356C13.6112 23.3342 13.7553 22.9736 13.8956 22.7303C14.0886 22.3955 14.5051 22.3406 14.8663 22.463Z",
  fill: "url(#paint30_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8663 22.463C15.7752 22.7711 16.1341 23.2935 16.2549 23.5446L16.283 23.8356L16.2549 24.1936C16.1341 24.4446 15.7752 24.9 14.8663 25.2081C14.5051 25.3305 14.0886 25.2756 13.8956 24.9409C13.7553 24.6975 13.6112 24.3369 13.6112 23.8356C13.6112 23.3342 13.7553 22.9736 13.8956 22.7303C14.0886 22.3955 14.5051 22.3406 14.8663 22.463Z",
  fill: "url(#paint31_radial_3987_23845)"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.6804 22.463C17.7715 22.7711 17.4125 23.2935 17.2917 23.5446L17.2636 23.8356L17.2917 24.1936C17.4125 24.4446 17.7715 24.9 18.6804 25.2081C19.0416 25.3305 19.458 25.2756 19.651 24.9409C19.7913 24.6975 19.9354 24.3424 19.9354 23.8356C19.9354 23.3287 19.7913 22.9736 19.651 22.7303C19.458 22.3955 19.0416 22.3406 18.6804 22.463Z",
  fill: "url(#paint32_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6804 22.463C17.7715 22.7711 17.4125 23.2935 17.2917 23.5446L17.2636 23.8356L17.2917 24.1936C17.4125 24.4446 17.7715 24.9 18.6804 25.2081C19.0416 25.3305 19.458 25.2756 19.651 24.9409C19.7913 24.6975 19.9354 24.3424 19.9354 23.8356C19.9354 23.3287 19.7913 22.9736 19.651 22.7303C19.458 22.3955 19.0416 22.3406 18.6804 22.463Z",
  fill: "url(#paint33_radial_3987_23845)"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0178 23.2242C16.0373 23.041 16.1646 22.8882 16.3456 22.8537C16.6364 22.7981 16.8896 22.7981 17.1804 22.8537C17.3613 22.8882 17.4887 23.041 17.5082 23.2242C17.5503 23.6194 17.5504 24.0018 17.5082 24.3982C17.4887 24.5814 17.3613 24.7342 17.1804 24.7688C16.8896 24.8243 16.6364 24.8243 16.3456 24.7688C16.1646 24.7342 16.0373 24.5814 16.0178 24.3982C15.9757 24.0033 15.9756 23.6203 16.0178 23.2242Z",
  fill: "url(#paint34_linear_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0178 23.2242C16.0373 23.041 16.1646 22.8882 16.3456 22.8537C16.6364 22.7981 16.8896 22.7981 17.1804 22.8537C17.3613 22.8882 17.4887 23.041 17.5082 23.2242C17.5503 23.6194 17.5504 24.0018 17.5082 24.3982C17.4887 24.5814 17.3613 24.7342 17.1804 24.7688C16.8896 24.8243 16.6364 24.8243 16.3456 24.7688C16.1646 24.7342 16.0373 24.5814 16.0178 24.3982C15.9757 24.0033 15.9756 23.6203 16.0178 23.2242Z",
  fill: "url(#paint35_radial_3987_23845)"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.8506 19.8291L27.4032 20.6543L26.2313 22.0762L24.7499 24.0684L27.8485 24.1153C27.9475 23.9434 28.0673 23.5489 28.2291 22.7875C28.3931 22.1273 28.5555 21.6739 28.7001 21.4121L29.1427 20.4883C29.2988 20.1623 29.1912 19.7711 28.8903 19.5709C28.5352 19.3346 28.0538 19.4541 27.8506 19.8291Z",
  fill: "#FFD942"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.9198 18.2474C25.8435 17.8662 26.1074 17.5005 26.4932 17.4529C26.8521 17.4085 27.1812 17.6576 27.2359 18.0151L27.5759 20.2367C27.5843 20.2912 27.5859 20.3465 27.5809 20.4014L27.566 20.564C27.561 20.6189 27.5642 20.6742 27.5669 20.7293C27.5816 21.0239 27.4203 21.2435 27.1122 21.2864C26.7931 21.3308 26.4946 21.1188 26.4314 20.8029L25.9198 18.2474Z",
  fill: "#FFDD46"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.4576 17.959C24.356 17.5643 24.6222 17.1695 25.0263 17.1159L25.0489 17.1129C25.4036 17.0658 25.7341 17.3019 25.8045 17.6527L26.3598 20.4174C26.4312 20.7728 26.1813 21.1125 25.8207 21.1501C25.5179 21.1817 25.2375 20.9868 25.1615 20.6919L24.4576 17.959Z",
  fill: "#FFD343"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.4065 18.8034C23.3086 18.4113 23.5731 18.021 23.9736 17.9667C24.3283 17.9185 24.6595 18.1544 24.73 18.5054L25.2855 21.2714C25.3567 21.6256 25.1076 21.9642 24.7482 22.0017C24.4446 22.0333 24.164 21.8367 24.0901 21.5406L23.4065 18.8034Z",
  fill: "#FFC93E"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4136 19.8807C22.3189 19.4892 22.5854 19.1014 22.9845 19.0473C23.3398 18.999 23.673 19.235 23.7436 19.5866L24.1039 21.3804C24.22 21.9581 23.5647 22.3763 23.0895 22.0279C22.9667 21.9378 22.8797 21.8072 22.8439 21.6592L22.4136 19.8807Z",
  fill: "#FFC239"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9891 22.2129C23.1079 22.6763 23.5751 23.669 23.7938 24.1074H27.8407L27.5829 20.3184L22.7469 21.2421C22.7782 21.3726 22.8704 21.7494 22.9891 22.2129Z",
  fill: "url(#paint36_radial_3987_23845)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9891 22.2129C23.1079 22.6763 23.5751 23.669 23.7938 24.1074H27.8407L27.5829 20.3184L22.7469 21.2421C22.7782 21.3726 22.8704 21.7494 22.9891 22.2129Z",
  fill: "url(#paint37_radial_3987_23845)"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.80271 17.6937C6.54585 17.3466 6.61901 16.857 6.96611 16.6002C7.30898 16.3465 7.79195 16.4144 8.05155 16.7528L8.98268 17.9667C9.31879 18.4049 9.50096 18.9417 9.50096 19.494L8.0019 19.3142L6.80271 17.6937Z",
  fill: "url(#paint38_radial_3987_23845)"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2731 16.7539C4.61509 16.5202 5.08178 16.608 5.31547 16.95C5.37698 17.04 5.42986 17.1255 5.48072 17.2077C5.62204 17.4362 5.74778 17.6395 5.99992 17.8448C6.2919 18.0826 6.79424 18.3302 7.74696 18.2655C8.16022 18.2374 8.518 18.5496 8.54608 18.9629C8.57416 19.3762 8.2619 19.7339 7.84864 19.762C6.55917 19.8496 5.67089 19.5113 5.05272 19.0079C4.5754 18.6192 4.27275 18.1178 4.13642 17.892C4.11073 17.8494 4.09094 17.8167 4.07701 17.7963C3.84331 17.4543 3.9311 16.9876 4.2731 16.7539Z",
  fill: "url(#paint39_radial_3987_23845)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2731 16.7539C4.61509 16.5202 5.08178 16.608 5.31547 16.95C5.37698 17.04 5.42986 17.1255 5.48072 17.2077C5.62204 17.4362 5.74778 17.6395 5.99992 17.8448C6.2919 18.0826 6.79424 18.3302 7.74696 18.2655C8.16022 18.2374 8.518 18.5496 8.54608 18.9629C8.57416 19.3762 8.2619 19.7339 7.84864 19.762C6.55917 19.8496 5.67089 19.5113 5.05272 19.0079C4.5754 18.6192 4.27275 18.1178 4.13642 17.892C4.11073 17.8494 4.09094 17.8167 4.07701 17.7963C3.84331 17.4543 3.9311 16.9876 4.2731 16.7539Z",
  fill: "url(#paint40_radial_3987_23845)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.15981 17.0664C3.50181 16.8327 3.9685 16.9205 4.20219 17.2625C4.23906 17.3164 4.27745 17.3747 4.31804 17.4364C4.48805 17.6947 4.69676 18.0118 4.9942 18.3126C5.35351 18.676 5.76233 18.9269 6.23998 18.9523C6.65361 18.9743 6.97109 19.3275 6.94909 19.7411C6.92708 20.1547 6.57394 20.4722 6.16031 20.4502C5.16921 20.3975 4.42959 19.875 3.92758 19.3672C3.51172 18.9467 3.20333 18.4744 3.03959 18.2236C3.00926 18.1771 2.98389 18.1383 2.96372 18.1088C2.73003 17.7668 2.81782 17.3001 3.15981 17.0664Z",
  fill: "url(#paint41_radial_3987_23845)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.15981 17.0664C3.50181 16.8327 3.9685 16.9205 4.20219 17.2625C4.23906 17.3164 4.27745 17.3747 4.31804 17.4364C4.48805 17.6947 4.69676 18.0118 4.9942 18.3126C5.35351 18.676 5.76233 18.9269 6.23998 18.9523C6.65361 18.9743 6.97109 19.3275 6.94909 19.7411C6.92708 20.1547 6.57394 20.4722 6.16031 20.4502C5.16921 20.3975 4.42959 19.875 3.92758 19.3672C3.51172 18.9467 3.20333 18.4744 3.03959 18.2236C3.00926 18.1771 2.98389 18.1383 2.96372 18.1088C2.73003 17.7668 2.81782 17.3001 3.15981 17.0664Z",
  fill: "url(#paint42_radial_3987_23845)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.11294 18.1836C3.45493 17.9499 3.92162 18.0377 4.15532 18.3797C4.46653 18.8351 5.12864 19.5841 6.00483 19.5841C6.41905 19.5841 6.75483 19.9198 6.75483 20.3341C6.75483 20.7483 6.41905 21.0841 6.00483 21.0841C4.3029 21.0841 3.24626 19.708 2.91685 19.2259C2.68315 18.884 2.77095 18.4173 3.11294 18.1836Z",
  fill: "url(#paint43_radial_3987_23845)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.11294 18.1836C3.45493 17.9499 3.92162 18.0377 4.15532 18.3797C4.46653 18.8351 5.12864 19.5841 6.00483 19.5841C6.41905 19.5841 6.75483 19.9198 6.75483 20.3341C6.75483 20.7483 6.41905 21.0841 6.00483 21.0841C4.3029 21.0841 3.24626 19.708 2.91685 19.2259C2.68315 18.884 2.77095 18.4173 3.11294 18.1836Z",
  fill: "url(#paint44_radial_3987_23845)"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41578 19.3403C3.74455 19.0883 4.21532 19.1506 4.46728 19.4794C4.71052 19.7968 5.29996 20.3614 6.26652 20.3614C6.68073 20.3614 7.01652 20.6972 7.01652 21.1114C7.01652 21.5256 6.68073 21.7806 6.26652 21.7806C4.58428 21.7806 3.67407 20.9103 3.27669 20.3918C3.02474 20.063 3.08701 19.5922 3.41578 19.3403Z",
  fill: "url(#paint45_radial_3987_23845)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.41578 19.3403C3.74455 19.0883 4.21532 19.1506 4.46728 19.4794C4.71052 19.7968 5.29996 20.3614 6.26652 20.3614C6.68073 20.3614 7.01652 20.6972 7.01652 21.1114C7.01652 21.5256 6.68073 21.7806 6.26652 21.7806C4.58428 21.7806 3.67407 20.9103 3.27669 20.3918C3.02474 20.063 3.08701 19.5922 3.41578 19.3403Z",
  fill: "url(#paint46_radial_3987_23845)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M5.96262 18.8917C5.71873 19.0549 5.59363 19.339 5.59363 19.6325V21.7402L6.21082 21.7793H9.51257V19.4511C9.51257 18.6152 8.70789 18.2011 7.54382 18.3027C6.88843 18.3599 6.33535 18.6423 5.96262 18.8917Z",
  fill: "url(#paint47_radial_3987_23845)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M5.96262 18.8917C5.71873 19.0549 5.59363 19.339 5.59363 19.6325V21.7402L6.21082 21.7793H9.51257V19.4511C9.51257 18.6152 8.70789 18.2011 7.54382 18.3027C6.88843 18.3599 6.33535 18.6423 5.96262 18.8917Z",
  fill: "url(#paint48_radial_3987_23845)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7616 18.3625C14.7616 17.3716 15.6623 16.5684 16.7733 16.5684C17.8844 16.5684 18.785 17.3716 18.785 18.3625V20.6883C18.785 21.6792 17.8844 22.4824 16.7733 22.4824C15.6623 22.4824 14.7616 21.6792 14.7616 20.6883V18.3625Z",
  fill: "url(#paint49_radial_3987_23845)"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_f_3987_23845)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.3532,
  cy: 20.7805,
  rx: 2.11983,
  ry: 0.475485,
  transform: "rotate(-11.0275 25.3532 20.7805)",
  fill: "url(#paint50_radial_3987_23845)"
}));

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.8152,
  cy: 14.6346,
  r: 1.73569,
  fill: "url(#paint51_radial_3987_23845)"
});

var _ref51 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_f_3987_23845)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.8147,
  cy: 14.6342,
  r: 1.03409,
  fill: "url(#paint52_linear_3987_23845)"
}));

var _ref52 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_i_3987_23845)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 21.7063,
  cy: 14.6346,
  r: 1.73569,
  fill: "url(#paint53_linear_3987_23845)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.7063,
  cy: 14.6346,
  r: 1.73569,
  fill: "url(#paint54_radial_3987_23845)"
}));

var _ref53 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_f_3987_23845)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 21.7054,
  cy: 14.6342,
  r: 1.03409,
  fill: "#FFBF34"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.7054,
  cy: 14.6342,
  r: 1.03409,
  fill: "url(#paint55_radial_3987_23845)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.7054,
  cy: 14.6342,
  r: 1.03409,
  fill: "url(#paint56_radial_3987_23845)"
}));

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint57_linear_3987_23845)"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint58_linear_3987_23845)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint59_radial_3987_23845)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint60_radial_3987_23845)"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint61_radial_3987_23845)"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4496 13.9977C11.4222 13.6717 11.389 12.7415 11.389 12.5023C11.389 12.225 11.5006 11.8923 11.7236 11.726L11.8909 11.5596C12.1698 11.3378 12.2813 11.0051 12.2813 10.6724V9.78521C12.2813 9.50796 12.4486 9.28616 12.7275 9.23071C13.3967 9.06436 14.7909 8.78711 16.7985 8.78711C18.8061 8.78711 20.2003 9.06436 20.8695 9.23071C21.0926 9.28616 21.3157 9.50796 21.3157 9.78521V10.6724C21.3157 11.0051 21.483 11.3378 21.706 11.5596C22.228 11.9254 22.1955 12.1266 22.1522 12.5577C22.1387 12.6913 22.0964 13.7996 22.0595 14.0546L21.7831 18.1701C21.6162 20.0099 20.1698 21.2922 18.4453 21.2922H15.1076C13.3274 21.2922 11.9367 20.0099 11.7698 18.1701L11.4496 13.9977Z",
  fill: "url(#paint62_linear_3987_23845)"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "#FFA91B"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint63_radial_3987_23845)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint64_linear_3987_23845)"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint65_radial_3987_23845)"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint66_radial_3987_23845)"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint67_radial_3987_23845)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7611 7.89963L21.7053 9.2304C22.4861 9.61855 23.4341 9.39678 23.2668 10.3394L22.6534 13.5001C22.5987 13.8265 22.3829 14.0462 22.0587 14.0543C22.0958 13.5308 22.1303 12.6861 22.1438 12.5525C22.189 12.1023 22.1181 11.9698 21.7053 11.5593C21.4822 11.3375 21.3149 11.0048 21.3149 10.6721V9.7849C21.3149 9.50765 21.0919 9.28585 20.8688 9.2304C20.1996 9.06405 18.8054 8.7868 16.7978 8.7868C14.7901 8.7868 13.396 9.06405 12.7267 9.2304C12.4479 9.28585 12.2806 9.50765 12.2806 9.7849V10.6721C12.2806 11.0048 12.1691 11.3375 11.8902 11.5593L11.7229 11.7256C11.4999 11.892 11.3873 12.2395 11.3873 12.5168C11.4021 12.6785 11.424 13.6098 11.4489 13.9974C11.1372 13.9761 10.8836 13.7603 10.8306 13.4446L10.2172 10.284C10.1057 9.39678 10.4159 9.89805 11.1967 9.5099C12.2506 9.0479 12.7706 6.95806 13.619 6.23613C14.2325 5.68163 15.1247 5.51528 15.9055 5.90343C16.4632 6.06978 17.0766 6.06978 17.6343 5.90343C18.4708 5.62618 19.4188 5.84798 20.0881 6.45793L20.9246 7.28968C21.1476 7.56693 21.4265 7.73328 21.7611 7.89963Z",
  fill: "url(#paint68_radial_3987_23845)"
});

var _ref67 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4646 14.5073L15.612 16.2738C15.5063 16.6371 15.7599 17.0005 16.1192 17.0005H16.8855C17.2448 17.0005 17.4984 16.6315 17.3927 16.2738L16.8749 14.5073C16.7639 14.116 16.5808 14.116 16.4646 14.5073Z",
  fill: "#F1901C"
}));

var _ref68 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3543 14.3379L15.802 16.1043C15.6893 16.4677 15.9598 16.831 16.343 16.831H17.1601C17.5433 16.831 17.8138 16.4621 17.7011 16.1043L17.1488 14.3379C17.0305 13.9466 16.4783 13.9466 16.3543 14.3379Z",
  fill: "#FFCC28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3543 14.3379L15.802 16.1043C15.6893 16.4677 15.9598 16.831 16.343 16.831H17.1601C17.5433 16.831 17.8138 16.4621 17.7011 16.1043L17.1488 14.3379C17.0305 13.9466 16.4783 13.9466 16.3543 14.3379Z",
  fill: "url(#paint69_linear_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3543 14.3379L15.802 16.1043C15.6893 16.4677 15.9598 16.831 16.343 16.831H17.1601C17.5433 16.831 17.8138 16.4621 17.7011 16.1043L17.1488 14.3379C17.0305 13.9466 16.4783 13.9466 16.3543 14.3379Z",
  fill: "url(#paint70_linear_3987_23845)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.3543 14.3379L15.802 16.1043C15.6893 16.4677 15.9598 16.831 16.343 16.831H17.1601C17.5433 16.831 17.8138 16.4621 17.7011 16.1043L17.1488 14.3379C17.0305 13.9466 16.4783 13.9466 16.3543 14.3379Z",
  fill: "url(#paint71_linear_3987_23845)"
}));

var _ref69 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.7515 17.8886C16.224 17.8886 15.7282 17.7645 15.3114 17.5472C15.169 17.4748 15.016 17.6352 15.1057 17.7645C15.4539 18.2921 16.0605 18.6438 16.7515 18.6438C17.4425 18.6438 18.0492 18.2921 18.3973 17.7645C18.487 17.63 18.334 17.4748 18.1916 17.5472C17.7749 17.7645 17.2843 17.8886 16.7515 17.8886Z",
  stroke: "url(#paint72_radial_3987_23845)",
  strokeWidth: 0.2
}));

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7515 17.8886C16.224 17.8886 15.7282 17.7645 15.3114 17.5472C15.169 17.4748 15.016 17.6352 15.1057 17.7645C15.4539 18.2921 16.0605 18.6438 16.7515 18.6438C17.4425 18.6438 18.0492 18.2921 18.3973 17.7645C18.487 17.63 18.334 17.4748 18.1916 17.5472C17.7749 17.7645 17.2843 17.8886 16.7515 17.8886Z",
  fill: "#8A004F"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2333 13.147C19.912 13.147 20.4852 13.6149 20.6412 14.2471C20.6876 14.4284 20.5485 14.6012 20.363 14.6012H18.0447C17.8971 14.6012 17.7791 14.4663 17.8086 14.3188C17.9393 13.6528 18.5252 13.147 19.2333 13.147Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0188 13.4297C19.5331 13.4297 19.9461 13.847 19.9461 14.357C19.9461 14.4413 19.9335 14.5256 19.9124 14.6015H18.121C18.0999 14.5214 18.0873 14.4413 18.0873 14.357C18.0873 13.847 18.5046 13.4297 19.0188 13.4297Z",
  fill: "url(#paint73_radial_3987_23845)"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4877 14.3573C18.4877 14.0622 18.7237 13.8262 19.0188 13.8262C19.3138 13.8262 19.5499 14.0622 19.5499 14.3573C19.5499 14.4458 19.5288 14.5301 19.4909 14.6018H18.5509C18.5087 14.5301 18.4877 14.4458 18.4877 14.3573Z",
  fill: "black"
});

var _ref74 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9508 13.626C19.0169 13.7143 18.8788 13.8221 18.7218 13.9395C18.5648 14.0569 18.4483 14.1395 18.3822 14.0511C18.3161 13.9627 18.3899 13.7959 18.5469 13.6785C18.7039 13.5611 18.8848 13.5376 18.9508 13.626Z",
  fill: "#C7A7A3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9508 13.626C19.0169 13.7143 18.8788 13.8221 18.7218 13.9395C18.5648 14.0569 18.4483 14.1395 18.3822 14.0511C18.3161 13.9627 18.3899 13.7959 18.5469 13.6785C18.7039 13.5611 18.8848 13.5376 18.9508 13.626Z",
  fill: "url(#paint74_radial_3987_23845)"
}));

var _ref75 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.8448 14.2352C19.8105 13.9954 19.6702 13.8148 19.6044 13.7544L19.3344 14.0508L19.4562 14.2879L19.8448 14.2352Z",
  fill: "url(#paint75_linear_3987_23845)"
}));

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M14.263 13.147C13.5843 13.147 13.011 13.6149 12.8551 14.2472C12.8087 14.4284 12.9478 14.6013 13.1333 14.6013H15.4517C15.5992 14.6013 15.7173 14.4664 15.6878 14.3188C15.5571 13.6528 14.9669 13.147 14.263 13.147Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M14.478 13.4297C13.9638 13.4297 13.5507 13.847 13.5507 14.3571C13.5507 14.4414 13.5633 14.5257 13.5844 14.6015H15.3759C15.397 14.5215 15.4096 14.4414 15.4096 14.3571C15.4054 13.847 14.9923 13.4297 14.478 13.4297Z",
  fill: "url(#paint76_radial_3987_23845)"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0094 14.3573C15.0094 14.0622 14.7733 13.8262 14.4783 13.8262C14.1832 13.8262 13.9471 14.0622 13.9471 14.3573C13.9471 14.4458 13.9682 14.5301 14.0062 14.6018H14.9462C14.9841 14.5301 15.0094 14.4458 15.0094 14.3573Z",
  fill: "black"
});

var _ref79 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3259 14.2483C15.3259 13.9486 15.0822 13.7489 15.0164 13.6885L14.7167 13.9783L14.9011 14.3537L15.3259 14.2483Z",
  fill: "url(#paint77_linear_3987_23845)"
}));

var _ref80 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_f_3987_23845)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.1987,
  cy: 13.826,
  rx: 0.404848,
  ry: 0.20489,
  transform: "rotate(-27.914 14.1987 13.826)",
  fill: "#C7A7A3",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.1987,
  cy: 13.826,
  rx: 0.404848,
  ry: 0.20489,
  transform: "rotate(-27.914 14.1987 13.826)",
  fill: "url(#paint78_radial_3987_23845)"
}));

var _ref81 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6022 11.9724C19.3503 11.9025 19.83 12.1944 19.9464 12.3016C20.1457 12.4854 20.4563 12.4727 20.64 12.2733C20.8237 12.074 20.811 11.7634 20.6117 11.5797C20.2934 11.2864 19.5396 10.8987 18.5108 10.995C18.2409 11.0202 18.0425 11.2595 18.0678 11.5294C18.093 11.7993 18.3323 11.9977 18.6022 11.9724Z",
  fill: "url(#paint79_radial_3987_23845)"
}));

var _ref82 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter26_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.2792 11.8258C20.0619 11.6255 19.4451 11.2857 18.5567 11.3688",
  stroke: "#D76D5B",
  strokeWidth: 0.25,
  strokeLinecap: "round"
}));

var _ref83 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter27_i_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9005 11.9724C14.1524 11.9025 13.6727 12.1944 13.5563 12.3016C13.357 12.4854 13.0464 12.4727 12.8627 12.2733C12.679 12.074 12.6917 11.7634 12.891 11.5797C13.2092 11.2864 13.9631 10.8987 14.9919 10.995C15.2618 11.0202 15.4601 11.2595 15.4349 11.5294C15.4097 11.7993 15.1704 11.9977 14.9005 11.9724Z",
  fill: "url(#paint80_radial_3987_23845)"
}));

var _ref84 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter28_f_3987_23845)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.224 11.8258C13.4413 11.6255 14.0581 11.2857 14.9465 11.3688",
  stroke: "#D76D5B",
  strokeWidth: 0.25,
  strokeLinecap: "round"
}));

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 8.66211C10.9999 5.47353 13.5847 2.88867 16.7733 2.88867C19.9619 2.88867 22.5468 5.47353 22.5468 8.66211V10.3105H10.9999V8.66211Z",
  fill: "url(#paint81_radial_3987_23845)"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 8.66211C10.9999 5.47353 13.5847 2.88867 16.7733 2.88867C19.9619 2.88867 22.5468 5.47353 22.5468 8.66211V10.3105H10.9999V8.66211Z",
  fill: "url(#paint82_radial_3987_23845)"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 8.66211C10.9999 5.47353 13.5847 2.88867 16.7733 2.88867C19.9619 2.88867 22.5468 5.47353 22.5468 8.66211V10.3105H10.9999V8.66211Z",
  fill: "url(#paint83_radial_3987_23845)"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0482 7.91211C11.0165 8.1576 10.9999 8.40794 10.9999 8.66211V10.3105H22.5468V8.66211C22.5468 8.40794 22.5302 8.1576 22.4984 7.91211H11.0482Z",
  fill: "url(#paint84_radial_3987_23845)"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0482 7.91211C11.0165 8.1576 10.9999 8.40794 10.9999 8.66211V10.3105H22.5468V8.66211C22.5468 8.40794 22.5302 8.1576 22.4984 7.91211H11.0482Z",
  fill: "url(#paint85_linear_3987_23845)"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 9.00281,
  y: 9.23779,
  width: 15.5156,
  height: 1.74219,
  rx: 0.871094,
  fill: "url(#paint86_radial_3987_23845)"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 9.00281,
  y: 9.23779,
  width: 15.5156,
  height: 1.74219,
  rx: 0.871094,
  fill: "url(#paint87_radial_3987_23845)"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  x: 9.00281,
  y: 9.23779,
  width: 15.5156,
  height: 1.74219,
  rx: 0.871094,
  fill: "url(#paint88_linear_3987_23845)"
});

var _ref93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_3987_23845",
  x: 6.24988,
  y: 19.623,
  width: 21.2469,
  height: 10.3031,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.776471 0 0 0 0 0.745098 0 0 0 0 0.741176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_di_3987_23845",
  x: 15.6219,
  y: 27.4566,
  width: 2.07803,
  height: 2.07803,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.1,
  dy: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.792157 0 0 0 0 0.717647 0 0 0 0 0.788235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3987_23845"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3987_23845",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.075
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.831373 0 0 0 0 0.745098 0 0 0 0 0.803922 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_di_3987_23845",
  x: 15.6219,
  y: 25.4435,
  width: 2.07803,
  height: 2.07803,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.1,
  dy: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.792157 0 0 0 0 0.717647 0 0 0 0 0.788235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3987_23845"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3987_23845",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.075
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.831373 0 0 0 0 0.745098 0 0 0 0 0.803922 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i_3987_23845",
  x: 13.6766,
  y: 19.523,
  width: 6.55449,
  height: 3.70156,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.741176 0 0 0 0 0.666667 0 0 0 0 0.701961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_3987_23845",
  x: 12.6112,
  y: 21.9307,
  width: 8.32422,
  height: 4.8645,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_i_3987_23845",
  x: 13.6112,
  y: 22.4033,
  width: 2.67178,
  height: 2.8645,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.780392 0 0 0 0 0.270588 0 0 0 0 0.396078 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_i_3987_23845",
  x: 17.2636,
  y: 22.4033,
  width: 2.67178,
  height: 2.8645,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.780392 0 0 0 0 0.270588 0 0 0 0 0.396078 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_i_3987_23845",
  x: 15.9862,
  y: 22.812,
  width: 1.55359,
  height: 1.99854,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.827451 0 0 0 0 0.137255 0 0 0 0 0.317647 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_i_3987_23845",
  x: 24.7499,
  y: 19.3492,
  width: 4.76405,
  height: 4.76602,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.909804 0 0 0 0 0.658824 0 0 0 0 0.14902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_i_3987_23845",
  x: 25.9066,
  y: 17.4478,
  width: 2.27712,
  height: 3.84448,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.996078 0 0 0 0 0.713726 0 0 0 0 0.0862745 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_i_3987_23845",
  x: 24.4359,
  y: 17.1069,
  width: 2.43613,
  height: 4.04639,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.92549 0 0 0 0 0.643137 0 0 0 0 0.101961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_i_3987_23845",
  x: 23.3861,
  y: 17.9604,
  width: 2.31159,
  height: 4.04443,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.917647 0 0 0 0 0.631373 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_i_3987_23845",
  x: 22.3944,
  y: 19.041,
  width: 2.12305,
  height: 3.11401,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.870588 0 0 0 0 0.619608 0 0 0 0 0.219608 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_i_3987_23845",
  x: 6.64929,
  y: 16.3468,
  width: 3.00165,
  height: 3.14712,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.15,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.811765 0 0 0 0 0.588235 0 0 0 0 0.294118 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_f_3987_23845",
  x: 23.0204,
  y: 19.9121,
  width: 4.66544,
  height: 1.73657,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_f_3987_23845",
  x: 10.2806,
  y: 13.1001,
  width: 3.06818,
  height: 3.06812,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_i_3987_23845",
  x: 19.9706,
  y: 12.6489,
  width: 3.72137,
  height: 3.72144,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25,
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.85098 0 0 0 0 0.560784 0 0 0 0 0.376471 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_f_3987_23845",
  x: 20.1713,
  y: 13.1001,
  width: 3.06818,
  height: 3.06812,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_f_3987_23845",
  x: 14.8378,
  y: 13.4639,
  width: 3.32916,
  height: 4.28662,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_f_3987_23845",
  x: 15.5262,
  y: 13.7944,
  width: 2.45062,
  height: 3.28662,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_f_3987_23845",
  x: 14.8789,
  y: 17.3287,
  width: 3.74526,
  height: 1.51519,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_f_3987_23845",
  x: 18.258,
  y: 13.4725,
  width: 0.809772,
  height: 0.715625,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_f_3987_23845",
  x: 19.1344,
  y: 13.5544,
  width: 0.910437,
  height: 0.933447,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_f_3987_23845",
  x: 14.5167,
  y: 13.4885,
  width: 1.00925,
  height: 1.06528,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_f_3987_23845",
  x: 13.7282,
  y: 13.464,
  width: 0.940936,
  height: 0.72417,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_i_3987_23845",
  x: 18.0656,
  y: 10.73,
  width: 2.70428,
  height: 1.70166,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.698039 0 0 0 0 0.25098 0 0 0 0 0.313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter26_f_3987_23845",
  x: 18.0317,
  y: 10.831,
  width: 2.7725,
  height: 1.51973,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter27_i_3987_23845",
  x: 12.7328,
  y: 10.73,
  width: 2.70428,
  height: 1.70166,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.698039 0 0 0 0 0.25098 0 0 0 0 0.313726 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_3987_23845"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter28_f_3987_23845",
  x: 12.699,
  y: 10.831,
  width: 2.7725,
  height: 1.51973,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2,
  result: "effect1_foregroundBlur_3987_23845"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.9686 21.0762) rotate(135.22) scale(12.9545 12.5552)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.195375,
  stopColor: "#FBF2F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654795,
  stopColor: "#D4C4DA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.96863 25.3887) scale(2.75 6.1875)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DED4E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DED4E0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.2186 20.1387) rotate(90) scale(2.09375 3.28125)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFD8D5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EFD8D5",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.9999 25.9199) rotate(180) scale(1.75 11.7187)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.214286,
  stopColor: "#B1A0B8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1BED4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.6561 25.3262) rotate(-180) scale(1.15625 5.75902)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BEB4C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BEB4C6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.18738 11.8262) rotate(118.867) scale(2.78336 2.69564)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770201,
  stopColor: "#4BB8FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#357ACE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.24988 11.8887) rotate(115.145) scale(3.38309 2.95533)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.451506,
  stopColor: "#3A7AB4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826267,
  stopColor: "#5F679A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.1014 2.8457) rotate(118.867) scale(2.78336 2.69564)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770201,
  stopColor: "#FF894E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E35838"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.1639 2.9082) rotate(115.145) scale(3.38309 2.95533)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.451506,
  stopColor: "#DE5534",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826267,
  stopColor: "#B6424C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.0663 3.86133) rotate(118.867) scale(2.78336 2.69564)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770201,
  stopColor: "#9AE453"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C9946"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.6561 3.82617) rotate(105.03) scale(3.49455 3.40391)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.37513,
  stopColor: "#61A150",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826267,
  stopColor: "#415E58"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.0897 13.8184) rotate(118.867) scale(2.78336 2.69564)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770201,
  stopColor: "#FFFF54"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1AC3A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.9686 13.3574) rotate(47.153) scale(1.47049 2.16553)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B8A734"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4CC30",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.9061 13.8887) rotate(109.11) scale(3.46022 3.37046)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.346841,
  stopColor: "#F2C341",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.829048,
  stopColor: "#CF8B51"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.2499 27.8549) rotate(123.599) scale(1.36942 1.16163)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.212303,
  stopColor: "#F0DFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DCC8EC"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.2499 25.8417) rotate(123.599) scale(1.36942 1.16163)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.212303,
  stopColor: "#F0DFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DCC8EC"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.222 20.9825) rotate(90) scale(8.03125 2.40212)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E78C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6F5EA2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_3987_23845",
  x1: 22.5624,
  y1: 29.8263,
  x2: 21.8124,
  y2: 29.8263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A6CAD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7A6CAD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_3987_23845",
  x1: 20.6439,
  y1: 29.0138,
  x2: 21.0624,
  y2: 29.0138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D5096"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7160A4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.8568 23.1387) rotate(90) scale(6.1875 1.38818)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8566B5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7060A5"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.0624 24.1075) rotate(90) scale(5.25 0.609375)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#896BB4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#896BB4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint21_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.3124 28.2637) rotate(-69.8114) scale(8.51176 7.52413)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.723885,
  stopColor: "#775184",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775184"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.8568 21.7168) rotate(90) scale(6.42188 0.185059)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#784B89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#784B89",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint23_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.5626 20.7949) rotate(148.118) scale(4.60024 8.11652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8E6E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DABDC3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint24_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.4845 22.4824) rotate(-165.069) scale(0.485131 2.12245)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.107884,
  stopColor: "#DBCDD4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DBCDD4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_3987_23845",
  x1: 9.53113,
  y1: 27.4512,
  x2: 4.90613,
  y2: 27.4512,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECE4F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C0B5CD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_3987_23845",
  x1: 9.74988,
  y1: 27.0762,
  x2: 8.828,
  y2: 27.0762,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DECFD8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E5DDEE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_3987_23845",
  x1: 27.871,
  y1: 28.1416,
  x2: 22.8436,
  y2: 28.1416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE7F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.90676,
  stopColor: "#B9AAC8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_3987_23845",
  x1: 28.0897,
  y1: 27.8756,
  x2: 27.1678,
  y2: 27.8756,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0DDE3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0DDE3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint29_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.7754 23.3582) rotate(37.725) scale(2.19833 2.41434)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E7377C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D72C5E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.4158 23.8356) rotate(-164.222) scale(1.75573 2.92224)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.690378,
  stopColor: "#EF4C8B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF4C8B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint31_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.1093 23.8356) rotate(107.513) scale(1.66159 0.787004)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D61F4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D61F4D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint32_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.7712 23.3582) rotate(142.275) scale(2.19833 2.41434)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9387A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D02759"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint33_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.1308 23.8356) rotate(-15.778) scale(1.75573 2.92224)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.690378,
  stopColor: "#EF4C8B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF4C8B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear_3987_23845",
  x1: 16.763,
  y1: 22.812,
  x2: 16.763,
  y2: 24.8104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.351052,
  stopColor: "#EB3782"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C93857"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint35_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5397 23.5917) rotate(180) scale(0.391357 2.59279)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EC4182"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EC4182",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint36_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.0936 22.4556) rotate(161.776) scale(4.60604 4.44246)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.240534,
  stopColor: "#FFDA02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8986,
  stopColor: "#FFC12E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint37_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.9335 21.9379) rotate(163.091) scale(3.90165 13.4872)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.69937,
  stopColor: "#EDA628",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1923D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint38_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.85925 17.7323) rotate(139.97) scale(1.53045 3.638)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.129143,
  stopColor: "#FFCE38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A913"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint39_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.44198 17.5533) rotate(121.971) scale(1.4993 2.87027)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB32C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint40_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.97737 17.2875) rotate(106.358) scale(2.5933 3.98801)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.630198,
  stopColor: "#EFA929",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3863F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint41_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.06598 17.9729) rotate(116.602) scale(1.58621 2.70684)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB32C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint42_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.54502 17.6765) rotate(103.252) scale(2.85068 3.61973)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.630198,
  stopColor: "#EFA929",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3863F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint43_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.93859 18.9471) rotate(119.244) scale(1.40151 2.54623)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB32C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint44_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.40035 18.6916) rotate(104.751) scale(2.474 3.46652)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.630198,
  stopColor: "#EFA929",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3863F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint45_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.23425 19.9512) rotate(122.692) scale(1.24393 2.40994)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDD43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB32C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint46_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.68738 19.7325) rotate(106.794) scale(2.13937 3.36757)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.630198,
  stopColor: "#EFA929",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3863F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint47_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.51257 21.7793) rotate(-162.011) scale(3.69324 5.10277)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE23D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBD23"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint48_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.15613 21.7793) rotate(-84.6107) scale(0.831802 3.90571)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2991F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7B528",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint49_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.0311 20.3887) rotate(51.6544) scale(2.66964 3.04449)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.228556,
  stopColor: "#D27429"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E69530"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint50_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.1639 20.733) rotate(178.447) scale(2.70045 29.1455)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD709"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC32B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint51_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.0795 14.6346) scale(1.82448 3.19286)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.350532,
  stopColor: "#E6962B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CA8F29"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint52_linear_3987_23845",
  x1: 11.8147,
  y1: 14.9238,
  x2: 11.149,
  y2: 14.9238,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BD6A1E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D77A1C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear_3987_23845",
  x1: 22.8358,
  y1: 13.4998,
  x2: 21.9846,
  y2: 16.1367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC339"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint54_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.0931 14.3593) rotate(-36.0604) scale(1.06322 1.21352)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.542503,
  stopColor: "#FFC532"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC532",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint55_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.6624 15.4878) rotate(-61.4675) scale(1.78695 1.04591)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.689542,
  stopColor: "#F4A51A",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4A51A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint56_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.7054 14.6342) rotate(44.7077) scale(0.379177 0.488812)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E59B1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E59B1F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint57_linear_3987_23845",
  x1: 20.9477,
  y1: 15.0397,
  x2: 13.0079,
  y2: 16.2228,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE833"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91602,
  stopColor: "#F9A528"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint58_linear_3987_23845",
  x1: 11.1417,
  y1: 17.8426,
  x2: 13.546,
  y2: 17.529,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D19C3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D19C3A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint59_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.2619 12.9806) rotate(90) scale(8.92625 10.1921)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.526117,
  stopColor: "#FFA63F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.925308,
  stopColor: "#D4783E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint60_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.1908 13.3128) rotate(-90) scale(1.35894 1.67254)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBA0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA0D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint61_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.4519 13.278) rotate(-90) scale(1.44605 1.79829)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE911A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE911A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint62_linear_3987_23845",
  x1: 16.7816,
  y1: 10.1388,
  x2: 16.7816,
  y2: 12.3888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.236111,
  stopColor: "#D98827"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5A624",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint63_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.5901 6.61534) rotate(127.807) scale(5.82859 9.91204)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE336"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE336",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint64_linear_3987_23845",
  x1: 11.6975,
  y1: 14.3566,
  x2: 14.7146,
  y2: 8.99728,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E07027"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E07027",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint65_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.4512 10.8518) rotate(-95.2901) scale(2.08042 1.02174)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.22158,
  stopColor: "#FFB42C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB42C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint66_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.1458 12.8282) rotate(-66.3998) scale(2.2311 1.81964)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.478737,
  stopColor: "#E57D1C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E57D1C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint67_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.9453 5.6919) rotate(51.1339) scale(1.64489 1.45232)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCE2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCE2C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint68_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.1061 10.2478) rotate(-64.4528) scale(3.49808 1.20863)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD93A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD93A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint69_linear_3987_23845",
  x1: 15.8534,
  y1: 15.7244,
  x2: 16.8285,
  y2: 15.7244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAA416"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAA416",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint70_linear_3987_23845",
  x1: 17.7269,
  y1: 16.0595,
  x2: 16.6609,
  y2: 16.0443,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE721"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE721",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint71_linear_3987_23845",
  x1: 16.9537,
  y1: 16.831,
  x2: 16.9537,
  y2: 16.2355,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EB8A1C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EB8A1C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint72_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.6635 18.8057) rotate(-87.7543) scale(0.652658 1.95797)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD069"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBE30",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint73_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.0167 14.272) rotate(90) scale(0.938665 1.11068)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#925C51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#694B43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#804D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85534D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint74_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.7798 14.013) rotate(-127.812) scale(0.39307 0.541163)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.765532,
  stopColor: "#FFE6E2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966159,
  stopColor: "#FFE6E2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint75_linear_3987_23845",
  x1: 19.825,
  y1: 13.9816,
  x2: 19.499,
  y2: 14.1825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4948D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B4948D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint76_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.4801 14.2721) rotate(90) scale(0.938713 1.11074)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#925C51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#694B43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#804D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85534D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint77_linear_3987_23845",
  x1: 15.2537,
  y1: 13.9816,
  x2: 14.9277,
  y2: 14.1825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4948D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B4948D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint78_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.183 14.1532) rotate(-90.897) scale(0.513454 0.617193)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.765532,
  stopColor: "#FFE6E2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966159,
  stopColor: "#FFE6E2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint79_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.2999 11.979) rotate(-76.373) scale(0.868116 1.90451)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.656765,
  stopColor: "#C64F38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4F29"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint80_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.2028 11.979) rotate(-103.627) scale(0.868116 1.90451)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.656765,
  stopColor: "#C64F38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BB4F29"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint81_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.7186 4.57617) rotate(143.13) scale(6.875 6.025)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.179091,
  stopColor: "#5E5764"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#372F3C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint82_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.7811 7.70117) rotate(7.43141) scale(2.89935 4.51078)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B5A5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#38303E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint83_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.7733 8.32617) rotate(-90) scale(5.875 8.03906)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.760638,
  stopColor: "#5D5565",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D5565"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint84_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.4061 7.91211) rotate(90) scale(1.47656 8.28125)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9072CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#634D93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint85_linear_3987_23845",
  x1: 16.7733,
  y1: 7.91211,
  x2: 16.7733,
  y2: 8.09961,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#745BA5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#745BA5",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint86_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.2684 9.87061) rotate(-180) scale(7.1875 0.632813)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#605966"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#392F42"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint87_radial_3987_23845",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.00281 10.1089) scale(3.48438 2.01172)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B595E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E3843",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint88_linear_3987_23845",
  x1: 17.9559,
  y1: 10.98,
  x2: 17.9559,
  y2: 10.2144,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#543459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#462F5A",
  stopOpacity: 0
})));

function SvgManJuggling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManJuggling);
export default __webpack_public_path__ + "static/media/man-juggling.bc4bafb2.svg";
export { ForwardRef as ReactComponent };